/**
 * @description 取得可用查詢條件用
 */
export enum PolicyItemMandatory {
  /** 必選項目，不得取消勾選 */
  M = 'M',
  /** 可選項目，使用者可自行決定是否勾選，預設勾選 */
  O = 'O',
  /** 可選項目，使用者可自行決定是否勾選，預設不勾選 */
  N = 'N',
  /** 必選項目，不得取消勾選，不顯示於前台 */
  H = 'H'
}
